import * as React from "react";
// style, design
import { FormAreaTitle } from "../../../Base/Chapters/styles";
import { NumberInput, RadioGroup, Select } from "../../../Base/Fields";

// store, state
import { constants } from "../../../../../store/invoicingDebtSettings";
import { useFormInstanceField } from "../../../../../store/base";

export default ({ method }) => {
  const storeName = constants.STORE_NAME;

  const useDebtCollection = useFormInstanceField({
    storeName,
    fieldKey: "use_debt_collection",
  });

  const debtStartMode = useFormInstanceField({
    storeName,
    fieldKey: "debt_start_mode",
  });

  return (
    <>
      <FormAreaTitle>Automatisk kravhantering</FormAreaTitle>

      <RadioGroup
        title="Använd automatisk kravhantering"
        description="Om denna inställning är aktiv kommer en kravhanteringsprocess automatiskt att påbörjas efter förfallodatum på obetald faktura"
        {...{
          storeName,
          method,
          fieldKey: "use_debt_collection",
        }}
        forceHorizontalToolTipPlacement="left"
        options={[
          { label: "Ja", value: true },
          { label: "Nej", value: false },
        ]}
        defaultValue={false}
      />

      {useDebtCollection && (
        <>
          <NumberInput
            title="Antal dagar efter förfallodatum som krav inleds"
            {...{
              storeName,
              method,
              fieldKey: "send_to_debt_after_days",
            }}
          />
          <Select
            title="Börja krav på nivå"
            description={`Välj vilken nivå kravet ska inledas på. OBS: Förseningsavgift går enbart att använda på bolagskunder. Motsvarigheten för privatkunder är "Påminnelser"`}
            {...{
              storeName,
              method,
              fieldKey: "debt_start_mode",
            }}
          />
          {debtStartMode === 3 && (
            <Select
              title="Antal påminnelser att skicka innan inkassokrav"
              {...{
                storeName,
                method,
                fieldKey: "number_of_reminders",
              }}
            />
          )}

          <NumberInput
            title="Betalningsvillkor för krav i antal dagar"
            {...{
              storeName,
              method,
              fieldKey: "debt_term_days",
            }}
          />
        </>
      )}
    </>
  );
};
